module.exports = __webpack_public_path__ + "img/error.c8000257.svg";